import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { FeatureFlag } from 'src/app/bo/featureFlag';
import { HttpService } from 'src/app/services/http.service';

export const SHOW_OLD_CONFIGURATION_FEATURE_NAME = 'show-old-configuration';
export const SHOW_SETUP_ORGANIZATION_FEATURE_NAME = 'show-setup-organization';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly http = inject(HttpService);

  // Un échec de chargement reste « non chargé » (null) : sans les flags, on ne bascule
  // pas vers la nouvelle configuration.
  private readonly flags = toSignal(
    this.http.get<FeatureFlag[]>('FeatureFlag').pipe(catchError(() => of(null))),
    { initialValue: null }
  );

  readonly loaded = computed(() => this.flags() !== null);

  // Tant que les flags ne sont pas chargés (en attente ou en échec), l'ancien menu reste
  // affiché : sinon aucune des deux configurations ne serait accessible.
  readonly showOldConfiguration = computed(() => !this.loaded() || this.isEnabled(SHOW_OLD_CONFIGURATION_FEATURE_NAME));

  readonly showNewConfiguration = computed(() => !this.showOldConfiguration());

  isEnabled(featureName: string): boolean {
    return this.flags()?.some(f => f.featureName === featureName && f.isEnabled) ?? false;
  }
}
